import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import FormNovoUsuario from './FormNovoUsuario';
import { EXITED } from 'react-transition-group/Transition';



export default function Usuarios(props) {
    const toast = React.useRef(null); // Ref para o Toast

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const [usuarios, setUsuarios] = useState([]);
    const [usuario, setUsuario]= useState([]);
    const [visibleLeft, setVisibleLeft] = useState(false);

    const [verInativos, setVerInativos]= useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
        idrevenda: { value: '', matchMode: FilterMatchMode.CONTAINS },
        nomecompleto: { value: '', matchMode: FilterMatchMode.EQUALS },
        email: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

   
    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos === 't' ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);



    const [empresa, setEmpresa]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel

    const overlayBtn = useRef(null); // Referência para o botão de filtro

     const firstGet = useRef(false)
    
        useEffect(() => {
            if(!firstGet.current){
                firstGet.current = true
                getData();
            }
        }, []);

    useEffect(() => {
        if(!visible){
            setUsuario([])
        }
       

    }, [visible]);

    const getData = () => {
        console.log(dataEmpresa)
        clearFilters()

        setLoading(true);

        setTimeout(() => {

            Conexao.post('usuariosController/getUsuariosRevenda', { 
               idrevenda : dataEmpresa.idrevenda, 
               idempresa : dataEmpresa.idempresa
             })
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {

                        setUsuarios(response.data.payload);

                        setLoading(false);

                    } else {
                        setUsuarios([])
                        setLoading(false);
                       // showMessageToast('warn', "Não foi possível recuperar dados")
                    }

                }).catch(error => {
                    setUsuarios([])
                    setLoading(false);
                    showMessageToast('error', "Não foi possível recuperar dados")
                });

        }, 1000);
    };

    const deleteUsuarioRevenda = (user) => {
       
       
    

        setLoading(true);

        Conexao.post('usuariosController/deleteUsuarioRevenda', { 
               idrevenda : dataEmpresa.idrevenda, 
               idempresa : dataEmpresa.idempresa, 
               idusuario : user.idusuario
        })
        .then(response => {

            if (response.status === 200 && response.data.status === 'OK') {
                showMessageToast('success', "Usuário excluido com sucesso!")
                setUsuarios(usuarios.filter(item => item.idusuario !== user.idusuario));

                setLoading(false);

            } else {
                setUsuarios([])
                setLoading(false);
                 showMessageToast('warn', "Não foi possível excluir usuário")
            }

        }).catch(error => {
            setUsuarios([])
            setLoading(false);
            showMessageToast('error', "Não foi possível excluir usuário")
        });
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
        }));
    };

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
        const foundFields = [];
    
        // Verificando em cada campo se o filtro global está presente
        const fields = ['idempresa', 'idrevenda', 'nomecompleto', 'email'];
        fields.forEach(field => {
            const fieldValue = usuarios.map(usuario => usuario[field]?.toString().toLowerCase());
            const matches = fieldValue.some(val => val.includes(value.toLowerCase()));
            if (matches) {
                foundFields.push(field); // Adiciona o campo encontrado
            }
        });
    
        setFieldsFound(foundFields); // Atualiza o estado com os campos encontrados
    };
    
    
    
    const renderBotaoEditar = (row, opcao) => {
  
        return (
            <Button 
                icon="pi pi-pencil"
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}
                tooltip="Editar dados da empresa" tooltipOptions={{ position: 'left' }}
            />
        );
    };

    const renderBotaoDataclassic= (row, opcao) => {
  
        return (
            <Button 
                icon= "pi pi-cog"
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}
                tooltip="Alterar configurações da integração com o Dataclassic" tooltipOptions={{ position: 'left' }}
            />
        );
    };
    const renderStatusRow= (row, opcao) => {

        return (
            row.ativo =='t' ? <Tag severity="success" value="ATIVO" style={{cursor :'pointer'}} onClick={()=>{

            }}></Tag> : <Tag severity="danger" value="INATIVO" style={{cursor :'pointer'}}></Tag>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-primary p-button-sm" 
                        onClick={getData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />            
                    <FormNovoUsuario 
                        Conexao={Conexao} 
                        dataEmpresa={dataEmpresa} 
                        edicao={usuario} 
                        updateData ={(data, operacao)=>{
                            if(operacao === 'insert'){
                                setUsuarios((prevData)=>([
                                    ...prevData, 
                                    data
                                ]))
                                setUsuario({
                                    idempresa : dataEmpresa.idempresa,
                                    nomeCompleto : "",
                                    email : "",
                                    senha : "",
                                    acessoClientes : "f",
                                    inclusaoClientes : "f",
                                    edicaoClientes : "f",
                                    exclusaoClientes : "f",
                                    acessoCollector : "f",
                                    collectorMonitorToner : "f",
                                    inclusaoCollector : "f",
                                    edicaoCollector : "f",
                                    exclusaoCollector : "f",
                                    acessoDcas : "f",
                                    inclusaoDcas : "f",
                                    edicaoDcas : "f",
                                    exclusaoDcas : "f",
                                    acessoEquipamentos : "f",
                                    equipamentosDetalhes : "f",
                                    equipamentosAtivacao : "f",
                                    equipamentosDesativacao : "f",
                                    equipamentosHabilitarToner : "f",
                                    relatorios : "f",
                                    idrevenda : dataEmpresa.idrevenda,
                                    ativo : "f"
                                })
                            }else{
                                /* setUsuarios((prevData)=>([
                                    ...usuarios.filter(item => item.idusuario !== data.idusuario), 
                                    {
                                    idusuario: data.idusuario,
                                    idempresa: data.idempresa,
                                    nomecompleto: data.nomeCompleto,
                                    email: data.email,
                                    senha: null ,
                                    clientes: data.acessoClientes,
                                    clientesinclusao: data.inclusaoClientes,
                                    clientesedicao: data.edicaoClientes,
                                    clientesexclusao:data.exclusaoClientes,
                                    collector:data.acessoCollector ,
                                    collectormonitorartoner: data.collectorMonitorToner,
                                    collectorinclusao:data.inclusaoCollector ,
                                    collectoredicao: data.edicaoCollector,
                                    collectorexcluxao: data.exclusaoCollector,
                                    dcas: data.acessoDcas,
                                    dcasinclusao: data.inclusaoDcas,
                                    dcasedicao: data.edicaoDcas,
                                    dcasexclusao: data.exclusaoDcas,
                                    equipametos: data.acessoEquipamentos,
                                    equipamentosdetalhes: data.equipamentosDetalhes,
                                    equipamentosativacao: data.equipamentosAtivacao,
                                    equipamentosdesativacao:data.equipamentosDesativacao ,
                                    equipamentoshabilitartoner: data.equipamentosHabilitarToner,
                                    relatorios: data.relatorios,
                                    idrevenda: data.idrevenda,
                                    ativo: data.ativo 
                                    }
                                 ]))*/
                                getData()

                                setUsuario({
                                    idempresa : dataEmpresa.idempresa,
                                    nomeCompleto : "",
                                    email : "",
                                    senha : "",
                                    acessoClientes : "f",
                                    inclusaoClientes : "f",
                                    edicaoClientes : "f",
                                    exclusaoClientes : "f",
                                    acessoCollector : "f",
                                    collectorMonitorToner : "f",
                                    inclusaoCollector : "f",
                                    edicaoCollector : "f",
                                    exclusaoCollector : "f",
                                    acessoDcas : "f",
                                    inclusaoDcas : "f",
                                    edicaoDcas : "f",
                                    exclusaoDcas : "f",
                                    acessoEquipamentos : "f",
                                    equipamentosDetalhes : "f",
                                    equipamentosAtivacao : "f",
                                    equipamentosDesativacao : "f",
                                    equipamentosHabilitarToner : "f",
                                    relatorios : "f",
                                    idrevenda : dataEmpresa.idrevenda,
                                    ativo : "f"
                                })
                            }
                           
                        }}
                        visible={visible} setVisible={(op)=>setVisible(op)}/>
                </div>
                <div className="flex flex-column align-items-start mb-3">
                    <span className="text-small">Inativos</span>
                    <InputSwitch checked={verInativos}
                        onChange={() => {
                            setVerInativos(prev => !prev)
                        }
                            
                        }/>
                </div>
            </div>
        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {usuarios.length} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {usuarios.length} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
            idrevenda: { value: '', matchMode: FilterMatchMode.CONTAINS },
            nomecompleto: { value: '', matchMode: FilterMatchMode.EQUALS },
            email: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
        });
        setFieldsFound([]); // Resetando os campos encontrados
    };



    useEffect(()=>{

    }, [fieldsFound])
    

    

    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={usuarios}
                            paginator                 
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
                            rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody, width : '50%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="email" 
                                header="Email" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo email" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="nomecompleto" header="Nome Completo" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo nome" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '5%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                header="Editar" 
                                body={(rowData)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <BotaoEditar  onClick={()=>{
                                    setUsuario(rowData)
                                    setVisible(true)
                                }}/>}
                                />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '5%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                header="Excluir" 
                                body={(rowData)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <BotaoExcluir onClick ={()=>{
                                    confirmDialog({
                                            message: 'Deseja excluir este usuário?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {deleteUsuarioRevenda(rowData)}
                                        });
                                    //deleteUsuarioRevenda
                                }}/>} 
                                />

                          
                        </DataTable>
                    
                </div>

                
            </div>
            
           
             <Toast ref={toast} />
        </Layout>
    );
}
